import React from "react";
import PropTypes from "prop-types";
import "../Restaurants/Restaurants.scss";

const TagFilterMenu = ({
  allTags,
  activeTag,
  setActiveTag,
  allLabel,
  ariaLabel,
  tagEmoji,
  tagCounts,
  totalCount,
}) => {
  if (!allTags || allTags.length === 0) return null;

  return (
    <div className="restaurants-filter" role="toolbar" aria-label={ariaLabel}>
      <div className="rf-list">
        <button
          type="button"
          className={`rf-chip ${activeTag === "" ? "active" : ""}`}
          aria-pressed={activeTag === ""}
          onClick={() => setActiveTag("")}
        >
          <span className="rf-text">
            {allLabel}{" "}
            <span className="rf-count">({totalCount ?? allTags.length})</span>
          </span>
        </button>
        {allTags.map((tag) => {
          const emoji = tagEmoji ? tagEmoji(tag) : "";
          const count = tagCounts?.[tag] ?? 0;
          return (
            <button
              key={tag}
              type="button"
              className={`rf-chip ${activeTag === tag ? "active" : ""}`}
              aria-pressed={activeTag === tag}
              onClick={() => setActiveTag(tag)}
            >
              {emoji && (
                <span className="rf-emoji" aria-hidden="true">
                  {emoji}
                </span>
              )}
              <span className="rf-text">
                {tag} <span className="rf-count">({count})</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

TagFilterMenu.propTypes = {
  allTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTag: PropTypes.string.isRequired,
  setActiveTag: PropTypes.func.isRequired,
  allLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  tagEmoji: PropTypes.func,
  tagCounts: PropTypes.objectOf(PropTypes.number),
  totalCount: PropTypes.number,
};

export default TagFilterMenu;
